import { render, staticRenderFns } from "./Ploydetail.vue?vue&type=template&id=74168674&scoped=true&"
import script from "./Ploydetail.vue?vue&type=script&lang=js&"
export * from "./Ploydetail.vue?vue&type=script&lang=js&"
import style0 from "./Ploydetail.vue?vue&type=style&index=0&id=74168674&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74168674",
  null
  
)

export default component.exports